var map = {
	"./arrow.svg": "21e2",
	"./close.svg": "8b1b",
	"./dimensie-dagelijks_functioneren.svg": "334d",
	"./dimensie-kwaliteit_van_leven.svg": "0cb5",
	"./dimensie-lichaamsfuncties.svg": "880c",
	"./dimensie-mentaal_welbevinden.svg": "cff2",
	"./dimensie-sociaal_maatschappelijk_participeren.svg": "9e56",
	"./dimensie-zingeving.svg": "48fb",
	"./fullscreen-close.svg": "1915",
	"./fullscreen-open.svg": "acc4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";